import type { ChecklistTaskId } from "../types";

export type ChecklistTask = {
  id: ChecklistTaskId;
  title: string;
  blurb: string;
  /** Internal route (react-router Link) the CTA navigates to, if any. */
  href?: string;
  /** External URL (mobile stores) — opens a new tab and self-completes. */
  externalHref?: string;
  ctaLabel: string;
};

/**
 * The getting-started checklist. Every task is real product use (not a
 * tooltip lecture); each links to where the action happens, with the guides
 * page anchors as the fallback teacher.
 */
export const checklistTasks: ChecklistTask[] = [
  {
    id: "explore_dashboard",
    title: "Explore your dashboard",
    blurb: "Click into a widget — drag headers to rearrange, edges to resize.",
    href: "/dashboard",
    ctaLabel: "Go to dashboard",
  },
  {
    id: "create_watchlist",
    title: "Create a watchlist",
    blurb: "Track your names and keywords across every feed.",
    href: "/watchlists-filters?create=ticker",
    ctaLabel: "Create one",
  },
  {
    id: "apply_filter",
    title: "Filter or highlight a feed",
    blurb: "Use a widget's filter panel to cut noise or make your names pop.",
    href: "/guides#watchlists",
    ctaLabel: "See how",
  },
  {
    id: "set_notification",
    title: "Set up an alert",
    blurb: "Get a pop-up or sound when a watchlist matches a headline.",
    href: "/settings",
    ctaLabel: "Open settings",
  },
  {
    id: "listen_squawk",
    title: "Listen to the squawk",
    blurb: "Breaking news read to you live by the desk — our signature.",
    href: "/guides#squawk",
    ctaLabel: "Learn more",
  },
  {
    id: "download_app",
    title: "Get the mobile app",
    blurb: "Squawk audio and alerts in your pocket.",
    externalHref: "https://apps.apple.com/us/app/newsquawk/id6759158115",
    ctaLabel: "Download",
  },
];
